import { Component, OnInit, ViewChild } from "@angular/core";
import { DoctorsService } from "../../doctor-service/doctors.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { FilterPipe } from "ngx-filter-pipe";
import { DocLocalService } from "../../doctor-service/doc-local.service";
import { DoctypeService } from "src/app/doctype-section/doctype-service/doctype.service";
import { Router, ActivatedRoute } from "@angular/router";
import { take } from "rxjs/operators";
import { DialogService } from "primeng/dynamicdialog";

@Component({
  selector: "app-doc-popup",
  templateUrl: "./doc-popup.component.html",
  styleUrls: ["./doc-popup.component.css"],
  providers: []
})
export class DocPopupComponent implements OnInit {
  @ViewChild("dt", { static: true }) dataTable;

  filter;
  docArray = [];
  token: string;
  results = [];
  totalItmes = 0;
  doctorTypeAray = [];
  isSearch = false;
  isFilter = null;
  name = null;
  city = null;
  state = null;
  type = null;
  clinic = null;
  first = null;
  constructor(
    private doctorService: DoctorsService,
    private authService: AuthService,
    private fil: FilterPipe,
    private docLocalService: DocLocalService,
    private docTypeService: DoctypeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe(auth => {
      this.token = auth._token;
    });
    // this.getDocFromDb("1");
    this.getDocType();
  }

  getDocFromDb(page) {
    this.doctorService.getDoctorFromDb(this.token, page).subscribe(res => {
      this.docArray = res.docData;
      this.first = res.page - 1;
      this.totalItmes = res.total;
      this.docLocalService.saveDocArray(this.docArray);
      console.log(this.docArray);
    });
  }

  search(event) {
    console.log(event);
    if (event.query !== "") {
      let result = this.fil.transform(this.docArray, { name: event.query });
      this.docArray = result;
    }
  }
  onSearchChange(value) {
    if (value !== "") {
      this.name = value;
      this.isSearch = true;
      this.isFilter = "name";
      this.filterDocByNameFromDb(1, value);
      // let result = this.fil.transform(this.docArray, { name: value });
      //  this.docArray = result;
    } else {
      this.docArray = this.docLocalService.getDocArray();
      this.isSearch = false;
      this.isFilter = null;
      this.name = null;
    }
  }
  onSearchChangeType(value) {
    if (value !== "All") {
      this.isSearch = true;
      this.type = value;
      this.isFilter = "type";
      this.filterDocByTypeFromDb(1, value);
      // let result = this.fil.transform(this.docArray, { name: value });
      //  this.docArray = result;
    } else {
      this.isSearch = false;
      this.docArray = this.docLocalService.getDocArray();
      this.isFilter = null;
      this.type = null;
    }
  }
  onSearchChangeCity(value) {
    if (value !== "") {
      this.isFilter = "city";
      this.city = value;
      this.isSearch = true;
      this.filterDocByCityFromDb(1, value);
      // let result = this.fil.transform(this.docArray, { name: value });
      //  this.docArray = result;
    } else {
      this.docArray = this.docLocalService.getDocArray();
      this.isSearch = false;
      this.isFilter = null;
      this.city = null;
    }
  }
  onSearchChangeClinic(value) {
    if (value !== "") {
      this.isSearch = true;
      this.isFilter = "clinic";
      this.clinic = value;
      this.filterDocByClinicFromDb(1, value);
      // let result = this.fil.transform(this.docArray, { name: value });
      //  this.docArray = result;
    } else {
      this.docArray = this.docLocalService.getDocArray();
      this.isSearch = false;
      this.clinic = null;
    }
  }
  onSearchChangeState(value) {
    if (value !== "") {
      this.isSearch = true;
      this.isFilter = "state";
      this.state = value;
      this.filterDocByStateFromDb(1, value);
      // let result = this.fil.transform(this.docArray, { name: value });
      //  this.docArray = result;
    } else {
      this.docArray = this.docLocalService.getDocArray();
      this.isSearch = false;
      this.state = null;
    }
  }
  getDocType() {
    this.docTypeService.getDocType(this.token).subscribe(res => {
      if (res && res.length > 0) {
        res.forEach(singleElem => {
          this.doctorTypeAray.push({
            name: singleElem.name,
            id: singleElem._id
          });
        });
      }
    });
  }
  onSelectDoctor(id) {
    //  const id = this.docArray[index]._id;
    this.router.navigate(["/pas", "doctors", "profile"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: id, appointment: true }
    });
    this.dialogService.dialogComponentRef.destroy();
  }
  loadCarsLazy(event) {
    let page = event.first + 1;
    if (this.isSearch) {
      if (this.isFilter && this.isFilter === "name" && this.name) {
        this.filterDocByNameFromDb(page, this.name);
      } else if (this.isFilter && this.isFilter === "city" && this.city) {
        this.filterDocByCityFromDb(page, this.city);
      } else if (this.isFilter && this.isFilter === "clinic" && this.clinic) {
        this.filterDocByClinicFromDb(page, this.clinic);
      } else if (this.isFilter && this.isFilter === "state" && this.state) {
        this.filterDocByStateFromDb(page, this.state);
      } else if (this.isFilter && this.isFilter === "type" && this.type) {
        this.filterDocByTypeFromDb(page, this.type);
      } else {
        this.getDocFromDb(page);
      }
    } else {
      console.log(event);
      this.getDocFromDb(page);
    }
  }
  filterDocByClinicFromDb(page, value) {
    this.doctorService
      .getFilterDoctorClinicFromDb(value, this.token, page)
      .subscribe(res => {
        this.docArray = res.docData;
        this.first = res.page - 1;
        this.totalItmes = res.total;
      });
  }

  filterDocByStateFromDb(page, value) {
    this.doctorService
      .getFilterDoctorStateFromDb(value, this.token, page)
      .subscribe(res => {
        this.docArray = res.docData;
        this.first = res.page - 1;
        this.first = res.page - 1;
        this.totalItmes = res.total;
      });
  }
  filterDocByCityFromDb(page, value) {
    this.doctorService
      .getFilterDoctorCityFromDb(value, this.token, page)
      .subscribe(res => {
        this.docArray = res.docData;
        this.first = res.page - 1;
        this.totalItmes = res.total;
      });
  }
  filterDocByTypeFromDb(page, value) {
    this.doctorService
      .getFilterDoctorTypeFromDb(value, this.token, page)
      .subscribe(res => {
        this.docArray = res.docData;
        this.first = res.page - 1;
        this.totalItmes = res.total;
      });
  }
  filterDocByNameFromDb(page, value) {
    this.doctorService
      .getFilterDoctorFromDb(value, this.token, page)
      .subscribe(res => {
        this.docArray = res.docData;
        this.first = res.page - 1;
        this.totalItmes = res.total;
      });
  }
}
